import React, { useContext, useEffect, useMemo, useState } from 'react'
import Select from 'react-select'
import Typography from '../../../../Typography'
import { currencyFormatter } from '../../../../../utils/functions'
import Button from '../../../../Button'
import styles from '../../Yearbooks/Yearbooks.module.sass'
import useBreakpoints from '../../../../../hooks/use-breakpoints'
import { Cart, OrderPackage } from '../../../../../models'
import TextInput from '../../../../TextInput'
import { useHistory } from 'react-router-dom'
import { CustomerContext } from '../../../../../contexts/CustomerContext'
import Sheet from '../../../../../models/Sheet';

const getSheets = (option, studentImages) => {
  if (!option.download) return [];

  const temp = Array.from(Array(parseInt(studentImages.length, 10)).keys());

  return temp.map((_, i) => (
    new Sheet({
      studentImage: studentImages[i],
      studentImageId: studentImages[i].id,
      imageTypeId: option.imageTypes[0].id,
    })
  ));
};

const CompositeForm = ({ student, school, studentImages, composite }) => {
  const breakpoint = useBreakpoints()
  const history = useHistory()
  const [useDigitalImagePackage, setUseDigitalImagePackage] = useState(false);
  const { customer, setCustomer } = useContext(CustomerContext)
  const quantityOptions = [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
    { label: '5', value: 5 },
  ]
  const [quantity, setQuantity] = useState(quantityOptions[0].value || 1)
  const [email, setEmail] = useState(customer && customer.email ? customer.email : '')
  const [existingCart, setExistingCart] = useState()

  useEffect(() => {
    if (!customer.cart) return

    Cart
      .where({ for_email: [customer.cart.id, customer.email] })
      .first()
      .then((response) => {
        if (!response.data) return;
        if (!response.data.purchased) setExistingCart(response.data)
      })
  }, [])

  const hasDigitalImages = useMemo(() => composite.options.some((option) => option.download), [composite && composite.id]);

  const pricePerComposite = useMemo(() => {
    if (!composite) return 0;

    const prices = composite
      .options
      .filter((opt) => {
        if (useDigitalImagePackage) return opt.download;

        return true;
      })
      .map((opt) => opt.prices)
      .flat();

    const schoolPrice = prices.find((price) => price.schoolId)

    if (schoolPrice) return schoolPrice.price

    return prices.find((price) => price.price).price
  }, [composite && composite.id, useDigitalImagePackage])

  const optionForPurchase = useMemo(() => (
    composite
      .options
      .filter((opt) => {
        if (useDigitalImagePackage) return opt.download;

        return true;
      })[0]
  ), [composite && composite.id, useDigitalImagePackage]);

  console.log(getSheets(optionForPurchase, studentImages));

  const handleSubmit = (evt) => {
    evt.preventDefault()

    const cart = existingCart || new Cart({ email, schoolId: student.schoolId })

    const orderPackages = Array.from(Array(parseInt(quantity, 10)).keys())

    cart.orderPackages = orderPackages.map(() => new OrderPackage({
      optionId: optionForPurchase && optionForPurchase.id,
      price: pricePerComposite,
      packageId: composite.id,
      studentId: student.id,
      sheets: getSheets(optionForPurchase, studentImages),
    }))

    cart
      .save({ with: [{ orderPackages: ['sheets'] }] })
      .then(() => {
        setCustomer({ ...customer, email, priorityCart: cart, currentStudent: student, currentSchool: school })
        history.push('/review')
      })
  }

  useEffect(() => {
    if (breakpoint === 'sm') {
      document.body.style.background = '#efefef'
    } else {
      document.body.style.background = '#fff'
    }
  }, [breakpoint])

  if (!composite) return null

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <div className={styles.bottom}>
        {history.length <= 2 && (
          <label className={styles.subrow}>
            <Typography>Email:</Typography>
            <TextInput required type="email" val={email} onChange={(evt) => setEmail(evt.target.value)} />
          </label>
        )}
        <label className={styles.subrow}>
          <Typography>Quantity:</Typography>
          <Select
            value={{ label: quantity.toString(), value: quantity }}
            onChange={(opt) => setQuantity(opt.value)}
            options={quantityOptions}
          />
        </label>
        {hasDigitalImages && (
          <label className={`${styles.subrow} ${styles.checkboxSubrow}`}>
            <input type="checkbox" onChange={() => setUseDigitalImagePackage((prev) => !prev)} />
            <Typography>Include Digital Images?</Typography>
          </label>
        )}
        <label className={styles.subrow}>
          <Typography>Subtotal:</Typography>
          <Typography weight="bold">{currencyFormatter(quantity * pricePerComposite)}</Typography>
        </label>
      </div>
      <Button fullWidth variant="primary" circular type="submit">Continue</Button>
    </form>
  )
}

export default CompositeForm
